import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { messages } from '../../../../../../messages';
import Block from '../../block';
import RelatedUrlsList from './related-url-list';
export const RelatedUrlsResolvedView = ({
  relatedUrlsResponse: {
    resolvedResults
  },
  renderers,
  testId,
  initializeOpened,
  ...blockProps
}) => {
  return /*#__PURE__*/React.createElement(Block, _extends({}, blockProps, {
    testId: testId
  }), resolvedResults && /*#__PURE__*/React.createElement(RelatedUrlsList, {
    testId: `${testId}-list`,
    renderers: renderers,
    initializeOpened: initializeOpened,
    title: messages.last_mentioned_in,
    resolvedResults: resolvedResults
  }));
};